import React, { PureComponent } from 'react';
import { Card, CardBody } from 'reactstrap';

import ChartHeader from './ChartHeader';

import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  //  YAxis,
  // CartesianGrid,
  ReferenceArea,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

export default class SmallChart extends PureComponent {
  render() {
    const {
      type = 'area',
      title,
      total = '0',
      trend = '0',
      data,
      totalSign = '',
      dataKey = 'value',
      stroke = '#f6da6e',
      fill = '#f6da6e',
      className
    } = this.props;

    const fillIdURL = `url(#${fill})`;
    const y2Value =
      data && data.length === 1 && type === 'area' ? data[0][dataKey] : null;

    return (
      <Card className={className}>
        <CardBody>
          <ChartHeader
            title={title}
            total={total}
            totalSign={totalSign}
            trend={trend}
          />
          <div className="card__chart">
            <ResponsiveContainer className="dashboard__area" minHeight={50}>
              {type === 'area' ? (
                <AreaChart
                  data={data}
                  height={100}
                  margin={{ top: 3, right: 0, bottom: 0, left: 0 }}
                >
                  <XAxis dataKey="date" tick={false} hide={true} />
                  {/* <YAxis type="number" name="views"/>
                  <CartesianGrid stroke="#eee" strokeDasharray="5 5"/>*/}
                  <Tooltip formatter={a => a.toLocaleString('en-US')} />
                  {y2Value && (
                    <ReferenceArea
                      y1={0}
                      y2={y2Value}
                      stroke={stroke}
                      fill={fill}
                      fillOpacity={0.5}
                    />
                  )}
                  <Area
                    type="monotone"
                    dataKey={dataKey}
                    stroke={stroke}
                    unit={totalSign}
                    data={true}
                    fill={fill}
                    fillOpacity={0.5}
                  />
                </AreaChart>
              ) : (
                <BarChart
                  data={data}
                  margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                >
                  <defs>
                    <linearGradient id={fill} x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={fill} stopOpacity={0.3} />
                      <stop offset="95%" stopColor={fill} stopOpacity={0.9} />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="date" tick={false} hide={true} />
                  <Tooltip formatter={a => a.toLocaleString('en-US')} />
                  <Bar dataKey={dataKey} fill={fillIdURL} />
                </BarChart>
              )}
            </ResponsiveContainer>
          </div>
        </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/chart/SmallChart.js